import {NgModule} from '@angular/core';
import {ExportationModalService} from './exportation-modal.service';
import {ExportationService} from './exportation.service';
import {ModalModule} from 'ngx-bootstrap';
import {ExportationModalComponent} from './exportation-modal.component';
import {SharedModule} from '../shared/shared.module';

@NgModule({
  declarations: [
    ExportationModalComponent
  ],
  exports: [
    ExportationModalComponent
  ],
  imports: [
    SharedModule,
    ModalModule.forRoot()
  ],
  providers: [
    ExportationService,
    ExportationModalService
  ],
  entryComponents: [
    ExportationModalComponent
  ]
})
export class ExportationModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/exportation/exportation.module.ts